import React, { useEffect, useState } from 'react';
import {
  Button, Card, Col, Divider, Input, Row, Select, Typography, notification,
} from 'antd';
import { attachQuestion, createQuestion, fetchAllQuestions } from '../api/transitions';
import { getChains } from '../api/answers';
import { showServerError } from '../api/errors';

const { Text } = Typography;

function AttachForm(props) {
  const { answer, ownerQuestionId, onAttached } = props;

  const [allQuestions, setAllQuestions] = useState([]);
  const [selectedId, setSelectedId] = useState(null);
  const [newText, setNewText] = useState('');
  const [busy, setBusy] = useState(false);

  const loadQuestions = async () => {
    try {
      setAllQuestions(await fetchAllQuestions());
    } catch (e) {
      showServerError(e, 'Не удалось загрузить список вопросов');
    }
  };

  useEffect(() => {
    loadQuestions();
  }, []);

  // Прячем то, что заведомо не примет сервер: уже привязанное к этому ответу
  // и сам вопрос-владелец. Остальные циклы ловит сервер — он видит весь граф.
  const attachedIds = getChains(answer).map((q) => q.id);
  const options = allQuestions
    .filter((q) => q.id !== ownerQuestionId && !attachedIds.includes(q.id))
    .map((q) => ({ value: q.id, label: q.questiontext }));

  const attachExisting = async () => {
    setBusy(true);
    try {
      await attachQuestion(answer.id, selectedId, attachedIds.length);
      notification.success({ message: 'Вопрос привязан' });
      setSelectedId(null);
      await onAttached();
    } catch (e) {
      showServerError(e, 'Не удалось привязать вопрос');
    }
    setBusy(false);
  };

  const createAndAttach = async () => {
    setBusy(true);
    try {
      const created = await createQuestion(newText);
      await attachQuestion(answer.id, created.id, attachedIds.length);
      notification.success({ message: 'Вопрос создан и привязан. Добавьте ему ответы ниже' });
      setNewText('');
      await loadQuestions();
      await onAttached();
    } catch (e) {
      showServerError(e, 'Не удалось создать и привязать вопрос');
    }
    setBusy(false);
  };

  return (
    <Card title="Привязать дополнительный вопрос" style={{ marginTop: '18px' }}>
      <Row gutter={8}>
        <Col span={18}>
          <Select
            style={{ width: '100%' }}
            size="large"
            showSearch
            allowClear
            placeholder="Выбрать существующий вопрос"
            value={selectedId}
            onChange={setSelectedId}
            options={options}
            filterOption={(input, option) => (option.label || '').toLowerCase().includes(input.toLowerCase())}
          />
        </Col>
        <Col span={6}>
          <Button
            type="primary"
            size="large"
            block
            loading={busy}
            disabled={!selectedId}
            onClick={attachExisting}
          >
            Привязать
          </Button>
        </Col>
      </Row>

      <Divider plain>или</Divider>

      <Row gutter={8}>
        <Col span={18}>
          <Input
            size="large"
            placeholder="Текст нового вопроса"
            value={newText}
            onChange={(e) => setNewText(e.target.value)}
          />
        </Col>
        <Col span={6}>
          <Button
            size="large"
            block
            loading={busy}
            disabled={!newText.trim().length}
            onClick={createAndAttach}
          >
            Создать и привязать
          </Button>
        </Col>
      </Row>

      <Text type="secondary" style={{ display: 'block', marginTop: '10px' }}>
        ** Один и тот же вопрос можно привязать к нескольким ответам,
        а к одному ответу — несколько вопросов. Цепочку, ведущую саму на себя,
        сервер не примет.
      </Text>
    </Card>
  );
}

export default AttachForm;
